import { Logo } from '../../UI/index'
import { GdprLogo, IsoLogo } from '../../Images'
import { FOOTER_STYLE } from '../style'
import { BRAND } from '../../../constants'
import { Footer as FooterType } from '../../../models/interfaces/Footer.interface'
import FooterLinks from './FooterLinks'

const { media } = BRAND

const Footer = ({ footer }: {footer: FooterType}) => {
  const {
    copyright_text,
    link_header_1,
    link_header_2,
    link_section_1,
    link_section_2,
    social_links_header,
    social_links
  } = footer

  return (
    <footer style={FOOTER_STYLE.footer}>
      <section className='links'>
        <div className='link-row'>
          <section className='logo-section'>
            <div>
              <Logo fill={'grey'} />
              <h5
                style={{ color: '#4a4c49', fontWeight: '400', padding: '20px 0px', whiteSpace: 'pre-line' }}>
                {JSON.parse(copyright_text)}
              </h5>
              <section className='icons'>
                <GdprLogo />
                <a href='/en/cp/iso'>
                  <IsoLogo />
                </a>
              </section>
            </div>
          </section>
          <FooterLinks links={link_section_1} title={link_header_1} />
        </div>
        <div className='link-row'>
          <FooterLinks links={link_section_2} title={link_header_2} />
          <FooterLinks links={social_links} title={social_links_header} />
        </div>
      </section>
      <style jsx>{`
        .logo-section {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .links {
          width: ${BRAND.layout.content}px;
          max-width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: flex-start;
          gap: 32px;
        }

        .link-row {
          display: flex;
          flex-direction: row;
          justify-content: space-evenly;
          flex: 1;
          gap: 32px;
          flex-wrap: nowrap;
        }

        .icons {
          display: flex;
          justify-content: space-between;
          width: 170px;
        }

        @media screen and (max-width: ${media.small + 150}px) {
          .links {
            flex-wrap: wrap;
            justify-content: space-between;
          }
        }

        @media screen and (max-width: 500px) {
          .links {
            flex-direction: column;
          }
          .link-row {
            flex-direction: column;
          }
        }
      `}</style>
    </footer>
  )
}

export default Footer